import React from 'react';
import { Button } from '../ui/Button';
import { FadeIn } from '../ui/FadeIn';
export function HeroSection() {
  return <section className="bg-charcoal text-cream pt-24 pb-24 px-6 relative overflow-hidden" data-id="element-85">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-86">
        <div className="z-10" data-id="element-87">
          <FadeIn data-id="element-88">
            <span className="text-copper font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-89">
              RESET 21: El Protocolo Anti-Inflamatorio (45+)
            </span>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif text-copper mb-6 leading-tight" data-id="element-90">
              Menopausia
              <br data-id="element-91" />
              <span className="text-cream" data-id="element-92">Sin Fármacos</span>
            </h1>
            <p className="text-xl md:text-2xl font-serif text-cream/90 mb-8 leading-relaxed" data-id="element-93">
              Desinflama tu abdomen y recupera tu claridad mental en 21 días con
              el método de nutrición celular diseñado para la mujer latina.
            </p>

            <div className="space-y-4" data-id="element-94">
              <Button className="w-full md:w-auto text-lg py-5 px-10" onClick={() => document.getElementById('oferta')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-95">
                ¡QUIERO MI RESET 21 AHORA!
              </Button>
              <p className="text-sm text-cream/60 flex items-center justify-center md:justify-start gap-2" data-id="element-96">
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-97">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-98" />
                </svg>
                Acceso inmediato tras la compra. Pago seguro y encriptado.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.2} className="relative z-10 flex justify-center lg:justify-end mt-12 lg:mt-0" data-id="element-99">
          <div className="relative w-full max-w-md aspect-[4/5]" data-id="element-100">
            <div className="absolute inset-0 bg-copper/20 rounded-full blur-3xl transform -translate-y-10" data-id="element-101"></div>
            <img src="https://cdn.magicpatterns.com/uploads/4m2vViTTwuAFUGuegCZJyb/heylloyd-Menopausia_sin_farmacos.png" alt="Menopausia Sin Fármacos Protocolo" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl" data-id="element-102" />
          </div>
        </FadeIn>
      </div>
    </section>;
}